import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import StatusDotIndicator from "./StatusDotIndicator";

type Props = {
  value: string;
};

const useStyles = makeStyles()({
  dotIndicator: {
    marginRight: 10,
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
  },
});

const StatusFilterItem: React.FC<Props> = ({ children, value }) => {
  const { classes } = useStyles();

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Box className={classes.dotIndicator}>
        <StatusDotIndicator status={value} />
      </Box>
      <Typography variant="body2" className={classes.label}>
        {children}
      </Typography>
    </Box>
  );
};

export default StatusFilterItem;
